(function() {
  'use strict';

  var registry = window.PooleaseSectionScripts = window.PooleaseSectionScripts || {};

  function initSection(section) {
    if (!section || section.dataset.disassemblyReady === 'true') return;
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia &&
      window.matchMedia('(max-width: 768px)').matches;

    var parts = Array.prototype.slice.call(
      section.querySelectorAll('[data-disassembly-part]')
    );
    if (!parts.length) return;
    section.dataset.disassemblyReady = 'true';

      // Reduced motion: skip all JS — CSS handles the static layout.
      if (reduceMotion) return;

      // Mobile / no IntersectionObserver: one-shot reveal as parts scroll
      // into view. Avoids scroll-progress jank on touch devices.
      if (isMobile || typeof IntersectionObserver === 'undefined') {
        if (typeof IntersectionObserver === 'undefined') {
          parts.forEach(function(p) { p.classList.add('is-revealed'); });
          return;
        }
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
        parts.forEach(function(p) { io.observe(p); });
        section._disassemblyCleanup = function() { io.disconnect(); };
        return;
      }

      // Desktop: scroll-driven hold + slide. Each part owns one viewport
      // slot within the section. Within a slot it spends most of the time
      // fully visible (HOLD phase → feels pinned, "fixed screen until next
      // scroll wheel response"), then quickly slides up and out as the next
      // slot enters. Slide-up + fade-out is what makes the previous part
      // physically leave the viewport instead of being covered in place.
      var ticking = false;
      var FADE_IN_END = 0.18;
      var HOLD_END = 0.82;
      var SLIDE_PX = 70;
      var n = parts.length;

      function getSectionProgress() {
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var total = rect.height - vh;
        if (total <= 0) return 0;
        var progress = -rect.top / total;
        if (progress < 0) return 0;
        if (progress > 1) return 1;
        return progress;
      }

      function update() {
        ticking = false;
        var progress = getSectionProgress();
        for (var i = 0; i < n; i++) {
          var isLast = (i === n - 1);
          var partProgress = progress * n - i;
          if (partProgress < 0) partProgress = 0;
          if (partProgress > 1) partProgress = 1;

          var opacity;
          var translateY;

          if (partProgress < FADE_IN_END) {
            // ENTER: slide up from below + fade in.
            var inT = partProgress / FADE_IN_END;
            opacity = inT;
            translateY = (1 - inT) * SLIDE_PX;
          } else if (partProgress < HOLD_END || isLast) {
            // HOLD: pinned in place — fixed screen until next scroll.
            opacity = 1;
            translateY = 0;
          } else {
            // EXIT: slide up out of viewport + fade out so the previous
            // step physically leaves the screen rather than being covered.
            var outT = (partProgress - HOLD_END) / (1 - HOLD_END);
            opacity = 1 - outT;
            translateY = -outT * SLIDE_PX;
          }

          parts[i].style.opacity = opacity.toFixed(3);
          parts[i].style.transform = 'translateY(' + translateY.toFixed(2) + 'px)';
        }
      }

      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      section._disassemblyCleanup = function() {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      };
      update();
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('.product-disassembly')) initSection(scope);
    var sections = scope.querySelectorAll ? scope.querySelectorAll('.product-disassembly') : [];
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (registry.productDisassembly) {
    registry.productDisassembly(document);
    return;
  }
  registry.productDisassembly = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function(event) {
    var section = event.target.matches('.product-disassembly')
      ? event.target
      : event.target.querySelector('.product-disassembly');
    if (section && section._disassemblyCleanup) section._disassemblyCleanup();
  });
})();
